"use client";
import useClient from '../hooks/useClient';
import Button from './button';

export default function ContactForm() {
    const { form, handleChange, handleSubmit } = useClient();

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div>
                <label htmlFor="nom" className="block text-black font-medium mb-2">Nom <span className="text-red-500">*</span></label>
                <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={form.nom}
                    onChange={handleChange}
                    placeholder="Entrez votre nom"
                    className="w-full px-3 py-2 bg-[#F2F4F0] border border-[#D4DDD1] rounded-lg focus:outline-none focus:border-[#2C6E63] transition-colors"
                    required
                />
            </div>
            <div>
                <label htmlFor="prenom" className="block text-black font-medium mb-2">Prénom <span className="text-red-500">*</span></label>
                <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    value={form.prenom}
                    onChange={handleChange}
                    placeholder="Entrez votre prénom"
                    className="w-full px-3 py-2 bg-[#F2F4F0] border border-[#D4DDD1] rounded-lg focus:outline-none focus:border-[#2C6E63] transition-colors"
                    required
                />
            </div>
            <div>
                <label htmlFor="email" className="block text-black font-medium mb-2">Adresse mail <span className="text-red-500">*</span></label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Entrez votre mail"
                    className="w-full px-3 py-2 bg-[#F2F4F0] border border-[#D4DDD1] rounded-lg focus:outline-none focus:border-[#2C6E63] transition-colors"
                    required
                />
            </div>
            <div>
                <label htmlFor="telephone" className="block text-black font-medium mb-2">Téléphone</label>
                <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={form.telephone}
                    onChange={handleChange}
                    placeholder="Entrez votre n° de portable"
                    className="w-full px-3 py-2 bg-[#F2F4F0] border border-[#D4DDD1] rounded-lg focus:outline-none focus:border-[#2C6E63] transition-colors"
                />
            </div>
            <div>
                <label htmlFor="message" className="block text-black font-medium mb-2">Message <span className="text-red-500">*</span></label>
                <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Entrez votre message"
                    className="w-full h-32 px-4 py-2 bg-[#F2F4F0] border border-[#D4DDD1] rounded-lg focus:outline-none focus:border-[#2C6E63] transition-colors"
                    required
                ></textarea>
            </div>

            {/* Honeypot - champ caché pour piéger les bots */}
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                <input
                    type="text"
                    name="website"
                    value={form.website}
                    onChange={handleChange}
                    tabIndex="-1"
                    autoComplete="off"
                />
            </div>

            <div className="text-center">
                <Button className="font-semibold py-2 px-6">
                    Envoyer
                </Button>
            </div>
        </form>
    );
}
